export default {
  data() {
    return {
      data: {},
      visible:false,
    }
  },


  methods: {

    init(id) {
      this.id = id
      this.visible = true
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.loading = true
      this.$request.assSupplier(this.id).then(resp => {
        this.loading = false
        this.data = this.$utils.conv(resp.data , { 'supplierNature':'companyNature'})
      })
    },
  },

  render(){
    const data = this.data || {}
    //col={3} layout="vertical"

    const title = '查看企业'
    return (
      <sl-side-panel v-model={this.visible} mask-closable={false} title={title} loading={this.loading}>
        <sl-detail-list label-width="110px" col={1} label-align="right" style="padding:12px;">
          <sl-detail-list-item title="供应商名称" content={data.supplierName} />
          <sl-detail-list-item title="统一信用代码" content={data.unionCreditCode} />
          <sl-detail-list-item title="注册资本" content={data.registeredCapital} />
          <sl-detail-list-item title="企业性质" content={data.supplierNatureText} />
          <sl-detail-list-item title="法人" content={data.legalPerson} />
          <sl-detail-list-item title="法人电话" content={data.legalPersonPhone} />
          <sl-detail-list-item title="联系人" content={data.contacts} />
          <sl-detail-list-item title="联系电话" content={data.contactsPhone} />
          <sl-detail-list-item title="注册地址" content={data.registeredAddress} />
          <sl-detail-list-item title="办公地点" content={data.officeSpace} />
          <sl-detail-list-item title="备注" content={data.remark} />
        </sl-detail-list>
      </sl-side-panel>
    )
  }
}
